import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { skipToken } from "@reduxjs/toolkit/query";
import { FaAddressCard, FaUser, FaMoneyBillWave } from "react-icons/fa";
import StepperComponent from "@/components/stepper";
import CustomDropdown from "@/components/CustomDropdown";
import "./index.less";
import {
  // useFetchAllBusinessUnitsQuery,
  useFetchAllCompanyJobGradesQuery,
  useFetchAllSectorsQuery,
  useFetchIndustriesQuery,
  useFetchSubIndustriesQuery,
  useFetchAllJobFunctionsQuery,
  useFetchJobFunctionByIdQuery,
  useCreateLivePayBenchmarkingReportMutation,
  useFetchAllCompaniesQuery,
  useFetchAllRelatedCompaniesQuery,
  useFetchCompanyJobFunctionsQuery,
  useFetchRegionsForLivePayQuery,
} from "@/services";
import { message } from "antd";
import customErrorMessage from "@/components/CustomErrorMessage";

// Steps
const steps = [
  { title: "Region and Country", icon: <FaAddressCard size={24} /> },
  { title: "Sector, Industry and Sub-industry", icon: <FaUser size={24} /> },
  { title: "Rewards Element", icon: <FaMoneyBillWave size={24} /> },
  { title: "Percentiles", icon: <FaMoneyBillWave size={24} /> },
  { title: "Aging", icon: <FaMoneyBillWave size={24} /> },
];

const dropdownConfig = {
  0: [
    { name: "region", label: "Region", placeholder: "Select your region..." },
    {
      name: "country",
      label: "Country",
      placeholder: "Select your country...",
    },
    {
      name: "city",
      label: "City",
      placeholder: "Enter your city...",
      type: "text",
    },
    {
      name: "reportFrom",
      label: "Report From",
      placeholder: "Start date",
      type: "date",
    },
    {
      name: "reportTill",
      label: "Report Till",
      placeholder: "End date",
      type: "date",
    },
    {
      name: "reportType",
      label: "Report Type",
      placeholder: "Select report type...",
    },
    {
      name: "dataSource",
      label: "Data Source",
      placeholder: "Select source...",
    },
    { name: "grade", label: "Grade", placeholder: "Select grade..." },
    {
      name: "jobFunction",
      label: "Job Function",
      placeholder: "Select job function...",
    },
    {
      name: "subJobFunction",
      label: "Sub Job Function",
      placeholder: "Select sub job function...",
    },
    // { name: "reportTitle", label: "Report Title", placeholder: "Enter title...", type: "text" },
  ],
  1: [
    { name: "sector", label: "Sector", placeholder: "Select sector..." },
    // { name: "companySize", label: "Company Size", placeholder: "Select size..." },
    { name: "industry", label: "Industry", placeholder: "Select industry..." },
    {
      name: "subIndustry",
      label: "Sub-Industry",
      placeholder: "Select sub-industry...",
    },
  ],
  2: [
    {
      name: "rewardElement",
      label: "Reward Element",
      placeholder: "Select reward...",
    },
  ],
  3: [
    {
      name: "showDataOn",
      label: "Show Data On",
      placeholder: "Select percentile...",
    },
  ],
  4: [
    { name: "ageFactor" },
    { name: "ageTo" },
    { name: "ageFactorCompany" },
    { name: "ageToCompany" },
  ],
};

const StepperForm = ({ reportName, handleClose, companyId }) => {
  const [selectedSectorId, setSelectedSectorId] = useState(null);
  const [selectedIndustryId, setSelectedIndustryId] = useState(null);
  const stepRefs = useRef([]);

  useEffect(() => {
    stepRefs.current = steps.map(
      (_, i) => stepRefs.current[i] || React.createRef()
    );
  }, []);

  const company_id = companyId;
  const [createLivePayBenchmarkingReport] =
    useCreateLivePayBenchmarkingReportMutation();
  // const { data: businessUnits } = useFetchAllBusinessUnitsQuery({ company_id });
  const { data: livePayRegions } = useFetchRegionsForLivePayQuery({ company_id });
  const { data: jobGradesData } = useFetchAllCompanyJobGradesQuery({
    company_id,
    paginate:false
  });
  const { data: sectorsData } = useFetchAllSectorsQuery(null);
  // const { data: industries } = useFetchIndustriesQuery({ id: company_id, page: 1 });
  // const { data: subIndustries } = useFetchSubIndustriesQuery({ id: company_id, page: 1 });
  const { data: jobFunctionsData } = useFetchAllJobFunctionsQuery({
    company_id,
  });
  const { data: allCompanies } = useFetchAllCompaniesQuery({ company_id });

  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [openSteps, setOpenSteps] = useState([0]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [createOwnPeerBasket, setCreateOwnPeerBasket] = useState(false);

  const selectedJobFunctionId = formData.jobFunction || null;
  const { data: subJobFunctionData, isLoading: subJobFunctionLoading } =
    useFetchJobFunctionByIdQuery(
      selectedJobFunctionId ? { job_id: selectedJobFunctionId } : skipToken
    );

  const { data, isLoading, isSuccess, isError, error } =
    useFetchCompanyJobFunctionsQuery({
      companyId: company_id,
      reportOn: formData.dataSource,
    });


  // const shouldFetchRelatedCompanies =
  //   formData.country &&
  //   formData.grade &&
  //   formData.jobFunction &&
  //   formData.subJobFunction;

  const shouldFetchRelatedCompanies =
    formData.country &&
    formData.dataSource &&
    ((formData.reportType === "grade" && formData.grade) ||
      (formData.reportType === "title" &&
        formData.jobFunction &&
        formData.subJobFunction));

  // const {
  //   data: allRelatedCompanies,
  //   isFetching: isFetchingRelatedCompanies,
  // } = useFetchAllRelatedCompaniesQuery(
  //   shouldFetchRelatedCompanies
  //     ? {
  //       country_id: formData.country,
  //       grade_id: formData.grade,
  //       job_function_id: formData.jobFunction,
  //       job_sub_function_id: Array.isArray(formData.subJobFunction)
  //         ? formData.subJobFunction[0] // Take first one if array
  //         : formData.subJobFunction,
  //     }
  //     : skipToken
  // );

  const { data: allRelatedCompanies, isFetching: isFetchingRelatedCompanies } =
    useFetchAllRelatedCompaniesQuery(
      shouldFetchRelatedCompanies
        ? {
          companyId,
          country_id: formData.country,
          report_on: formData.dataSource,
          grade_id:
            formData.reportType === "grade" ? formData.grade : undefined,
          job_function_id:
            formData.reportType === "title"
              ? formData.jobFunction
              : undefined,
          job_sub_function_id:
            formData.reportType === "title"
              ? Array.isArray(formData.subJobFunction)
                ? formData.subJobFunction[0]
                : formData.subJobFunction
              : undefined,
        }
        : skipToken
    );

  const { data: industries } = useFetchIndustriesQuery(
    selectedSectorId ? { id: selectedSectorId } : skipToken
  );

  const { data: subIndustries } = useFetchSubIndustriesQuery(
    selectedIndustryId ? { id: selectedIndustryId } : skipToken
  );

  useEffect(() => {
    setFormData(prev => ({ ...prev, createOwnPeerBasket }));
  }, [createOwnPeerBasket]);

  useEffect(() => {
    if (createOwnPeerBasket) {
      setFormData(prev => ({
        ...prev,
        custom_companies: [],
      }));
    }
  }, [
    formData.grade,
    formData.country,
    formData.jobFunction,
    formData.subJobFunction,
    formData.reportType,
  ]);

  const hookDataMap = {
    region:
      livePayRegions?.data?.map(bu => ({ label: bu.name, value: bu.id }))
      || [],
    // region:
    //   businessUnits?.data?.flatMap(bu =>
    //     bu.regions.map(region => ({ label: region.name, value: region.id }))
    //   ) || [],
    // country:
    //   businessUnits?.data?.reduce((acc, bu) => {
    //     bu.regions.forEach(region => {
    //       acc[region.name] = region.countries.map(country => ({
    //         label: country.name,
    //         value: country.id,
    //       }));
    //     });
    //     return acc;
    //   }, {}) || {},
    country:
      livePayRegions?.data?.reduce((acc, region) => {
        acc[region.name] = region.countries.map(country => ({
          label: country.name,
          value: country.id,
        }));
        return acc;
      }, {}) || {},

    grade:
      jobGradesData?.data?.map(grade => ({
        label: grade.grade,
        value: grade.id,
      })) || [],
    // jobFunction: jobFunctionsData?.data?.map(job => ({
    //   label: job.name,
    //   value: job.id,
    // })) || [],

    jobFunction:
      data?.data?.map(job => ({
        label: job.name,
        value: job.id,
      })) || [],

    subJobFunction:
      data?.data
        ?.find(jobf => jobf.id === selectedJobFunctionId)
        ?.job_sub_functions
        ?.map(sub => ({
          label: sub.name,
          value: sub.id,
        })) || [],


    // subJobFunction:
    // subJobFunction:
    //   subJobFunctionData?.data?.job_sub_functions?.map(sub => ({
    //     label: sub.name,
    //     value: sub.id,
    //   })) || [],
    // subJobFunction:
    // subJobFunctionData?.data?.job_sub_functions?.map(sub => ({
    //   label: sub.name,
    //   value: sub.id,
    // })) || [],
    sector:
      sectorsData?.data?.map(sector => ({
        label: sector.name,
        value: sector.id,
      })) || [],
    // industry: industries?.data?.map(industry => ({
    //   label: industry.name,
    //   value: industry.id,
    // })) || [],
    // subIndustry: subIndustries?.data?.map(sub => ({
    //   label: sub.name,
    //   value: sub.id,
    // })) || [],
    industry:
      industries?.data?.map(industry => ({
        label: industry.name,
        value: industry.id,
      })) || [],

    subIndustry:
      subIndustries?.data?.map(sub => ({
        label: sub.name,
        value: sub.id,
      })) || [],

    reportType: [
      { label: "Job Function/Sub Job Function", value: "title" },
      { label: "Grade", value: "grade" },
    ],
    dataSource: [
      { label: "Tom Data", value: "tom_data" },
      { label: "Payroll Data", value: "payroll_data" },
      { label: "Aggregate of both", value: "aggregate" },
    ],
    companySize: [
      { label: "Small", value: "small" },
      { label: "Medium", value: "medium" },
      { label: "Large", value: "large" },
    ],
    rewardElement: [
      { label: "Basic Pay", value: "basic_pay" },
      { label: "Guaranteed Cash / Base Pay", value: "guaranteed_cash" },
      { label: "TTC - Actual/Target", value: "ttc_actual" },
      { label: "TDC - Actual/Target", value: "tdc_actual" },
      { label: "TR - Actual/Target", value: "tr_actual" },
    ],
    showDataOn: [
      { label: "p10", value: "10" },
      { label: "p25", value: "25" },
      { label: "p50", value: "50" },
      { label: "p75", value: "75" },
      { label: "p90", value: "90" },
    ],
    peerCompanies:
      allRelatedCompanies?.data?.map(comp => ({
        label: comp.name,
        value: comp.id,
      })) || [],
  };


  const handlePeerBasketToggle = checked => {
    setCreateOwnPeerBasket(checked);

    if (checked) {
      setFormData(prev => ({
        ...prev,
        sector: null,
        industry: null,
        subIndustry: null,
        companySize: null,
      }));
    }
  };

  // const handleChange = (name, value) => {
  //   let updatedFormData = { ...formData, [name]: value };

  //   if (name === "jobFunction") {
  //     updatedFormData.subJobFunction = undefined;
  //   }

  //   if (name === "region") {
  //     updatedFormData.country = undefined;
  //   }

  //   if (name === "reportType") {
  //     if (value === "grade") {
  //       updatedFormData.jobFunction = undefined;
  //       updatedFormData.subJobFunction = undefined;
  //     } else if (value === "title") {
  //       updatedFormData.grade = undefined;
  //     }
  //   }

  //   if (name === "sector") {
  //     updatedFormData.industry = undefined;
  //     updatedFormData.subIndustry = undefined;
  //     setSelectedSectorId(value); // ✅ set new state for industry hook
  //   }

  //   if (name === "industry") {
  //     updatedFormData.subIndustry = undefined;
  //     setSelectedIndustryId(value); // ✅ set new state for subIndustry hook
  //   }

  //   setFormData(updatedFormData);
  // };

  const handleChange = (name, value) => {
    let updatedFormData = { ...formData };
    // 🔽 Handle "All" logic for multi-select dropdowns
    if (name === "grade" || name === "subJobFunction") {
      const isSelectingAll = Array.isArray(value) && value.includes("all");
      const options = hookDataMap[name]?.map(opt => opt.value) || [];

      if (isSelectingAll) {
        updatedFormData[name] = options;
      } else {
        updatedFormData[name] = value;
      }
    } else {
      updatedFormData[name] = value;
    }

    if (name === "dataSource") {
      updatedFormData.jobFunction = undefined;
      updatedFormData.subJobFunction = undefined;
      updatedFormData.grade = undefined;


    }
    // Reset sub-jobFunction when jobFunction changes
    if (name === "jobFunction") {
      updatedFormData.subJobFunction = undefined;
    }

    if (name === "region") {
      updatedFormData.country = undefined;
    }

    if (name === "reportType") {
      if (value === "grade") {
        updatedFormData.jobFunction = undefined;
        updatedFormData.subJobFunction = undefined;
      } else if (value === "title") {
        updatedFormData.grade = undefined;
      }
    }

    if (name === "sector") {
      updatedFormData.industry = undefined;
      updatedFormData.subIndustry = undefined;
      setSelectedSectorId(value);
    }

    if (name === "industry") {
      updatedFormData.subIndustry = undefined;
      setSelectedIndustryId(value);
    }

    setFormData(updatedFormData);
  };


  // const handleChange = (name, value) => setFormData({ ...formData, [name]: value });

  const handleSubmit = async () => {
    const transformedObj = {
      regions: [formData.region],
      countries: [formData.country],
      sectors: formData.sector ? [formData.sector] : [],
      industries: formData.industry ? [formData.industry] : [],
      sub_industries: formData.subIndustry ? [formData.subIndustry] : [],
      job_function:
        formData.reportType === "grade"
          ? []
          : formData.jobFunction
            ? [formData.jobFunction]
            : [],
      job_sub_function:
        formData.reportType === "grade"
          ? []
          : Array.isArray(formData.subJobFunction)
            ? formData.subJobFunction.filter(Boolean)
            : formData.subJobFunction
              ? [formData.subJobFunction]
              : [],

      // grades: formData.reportType === "title" ? [] : [formData.grade],
      grades:
        formData.reportType === "title"
          ? []
          : Array.isArray(formData.grade)
            ? formData.grade.filter(Boolean)
            : formData.grade
              ? [formData.grade]
              : [],

      custom_companies: createOwnPeerBasket
        ? formData.custom_companies || []
        : [],
      // name: formData.reportTitle || "UnnamedReport",
      name: reportName || "UnnamedReport",
      report_by: [formData.reportType],
      report_on: [formData.dataSource],
      company_size: formData.companySize ? [formData.companySize] : [],
      from_date: formData.reportFrom,
      to_date: formData.reportTill,
      // reward_elements: formData.rewardElement,
      reward_elements: Array.isArray(formData.rewardElement)
        ? formData.rewardElement.filter(Boolean)
        : formData.rewardElement
          ? [formData.rewardElement]
          : [],

      // percentiles: Array.isArray(formData.showDataOn)
      //   ? formData.showDataOn.map(Number)
      //   : [Number(formData.showDataOn)],
      percentiles: Array.isArray(formData.showDataOn)
        ? formData.showDataOn.filter(Boolean).map(Number)
        : formData.showDataOn
          ? [Number(formData.showDataOn)]
          : [],

      market_data_aging: Number(formData.ageFactor),
      company_data_aging: formData.ageFactorCompany
        ? Number(formData.ageFactorCompany)
        : null,
      city: formData.city,
      market_aging_date: formData.ageTo || null,
      company_aging_date: formData.ageToCompany || null,
    };

    try {
      const res = await createLivePayBenchmarkingReport({
        company_id, // Or dynamically from props/state
        body: transformedObj,
      }).unwrap();
      message.success("Report created successfully");
      handleClose();
    } catch (err) {
      console.error("Failed to create report:", err);

      if (err?.is_validation_error && err?.error) {
        // Loop through validation errors and show each with field name
        Object.entries(err.error).forEach(([field, errors]) => {
          if (Array.isArray(errors)) {
            errors.forEach(errMsg => {
              customErrorMessage(`${field}: ${errMsg}`);
            });
          } else {
            customErrorMessage(`${field}: ${errors}`);
          }
        });
      } else {
        // Generic fallback message
        customErrorMessage(err?.message || "Something went wrong");
      }
    }
  };

  const handleRegionChange = value => {
    setSelectedRegion(value);
    handleChange("region", value);
  };

  // const isStepValid = () => {
  //   const fields = dropdownConfig[currentStep] || [];

  //   if (currentStep === 1 && createOwnPeerBasket) {
  //     return (
  //       Array.isArray(formData.custom_companies) &&
  //       formData.custom_companies.length >= 10
  //     );
  //   }

  //   const allFilled = fields.every(field => {
  //     const name = field.name;

  //     const isDisabledField =
  //       (name === "grade" && formData.reportType === "title") ||
  //       ((name === "jobFunction" || name === "subJobFunction") &&
  //         formData.reportType === "grade");

  //     return isDisabledField || formData[name] !== undefined;
  //   });

  //   const peerCompanyValid =
  //     !createOwnPeerBasket ||
  //     (Array.isArray(formData.custom_companies) &&
  //       formData.custom_companies.length >= 10);

  //   return allFilled && peerCompanyValid;
  // };

  const optionalSteps = [1, 4]; // Example: make steps 1–4 optional

  const isStepValid = () => {
    // If step is marked optional, always valid
    if (optionalSteps.includes(currentStep)) return true;

    const fields = dropdownConfig[currentStep] || [];

    const allFilled = fields.every(field => {
      const name = field.name;
      const isDisabledField =
        (name === "grade" && formData.reportType === "title") ||
        ((name === "jobFunction" || name === "subJobFunction") &&
          formData.reportType === "grade");

      return isDisabledField || formData[name] !== undefined;
    });

    const peerCompanyValid =
      !createOwnPeerBasket ||
      (Array.isArray(formData.custom_companies) &&
        formData.custom_companies.length >= 10);

    return allFilled && peerCompanyValid;
  };

  // const isFormComplete = () => {
  //   const allFields = Object.values(dropdownConfig).flat();

  //   const allFilled = allFields.every(field => {
  //     const name = field.name;

  //     const isDisabledField =
  //       (name === "grade" && formData.reportType === "title") ||
  //       ((name === "jobFunction" || name === "subJobFunction") &&
  //         formData.reportType === "grade");

  //     return isDisabledField || formData[name] !== undefined;
  //   });

  //   const peerCompanyValid =
  //     !createOwnPeerBasket ||
  //     (Array.isArray(formData.custom_companies) &&
  //       formData.custom_companies.length >= 10);

  //   return allFilled && peerCompanyValid;
  // };

  const isFormComplete = () => {
    const allFields = Object.entries(dropdownConfig).flatMap(
      ([stepIndex, fields]) => {
        if (optionalSteps.includes(Number(stepIndex))) {
          return []; // skip fields from optional steps
        }
        return fields;
      }
    );

    const allFilled = allFields.every(field => {
      const name = field.name;
      const isDisabledField =
        (name === "grade" && formData.reportType === "title") ||
        ((name === "jobFunction" || name === "subJobFunction") &&
          formData.reportType === "grade");

      return isDisabledField || formData[name] !== undefined;
    });

    const peerCompanyValid =
      !createOwnPeerBasket ||
      (Array.isArray(formData.custom_companies) &&
        formData.custom_companies.length >= 10);

    return allFilled && peerCompanyValid;
  };

  const toggleStep = index => {
    setCurrentStep(index);
    setOpenSteps(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );

    // Scroll into view after render
    setTimeout(() => {
      const el = stepRefs.current[index];
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const handleNext = () => {
    const next = currentStep + 1;
    if (next < steps.length) {
      setCurrentStep(next);
      if (!openSteps.includes(next)) {
        setOpenSteps([...openSteps, next]);
      }

      // Scroll to the newly opened step after render
      setTimeout(() => {
        const el = stepRefs.current[next];
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100); // short delay to ensure DOM update
    }
  };

  const handleBack = () => {
    const prev = currentStep - 1;
    if (prev >= 0) {
      setCurrentStep(prev);

      setTimeout(() => {
        const el = stepRefs.current[prev];
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  };

  const renderDropdowns = stepIndex => {
    if (!openSteps.includes(stepIndex)) return null;

    // Special rendering for Aging step
    if (stepIndex === 4) {
      return (
        <div className="flex flex-col gap-6 items-center mt-4">
          <div className="w-full mt-6">
            <h3 className="text-lg font-semibold text-center mb-4 text-themeBlue">
              Aging Factor - My Data
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <label className="block mb-2 font-semibold text-lg text-themeBlue">
                  <p className="text-themeBlue">Aging Factor</p>
                </label>
                <div className="flex items-center gap-x-2 mt-5">
                  <div className="text-sm">0%</div>
                  <input
                    type="range"
                    className="w-full"
                    min={0}
                    max={100}
                    step={1}
                    value={formData.ageFactorCompany || 0}
                    onChange={e => handleChange("ageFactorCompany", e.target.value)}
                  />
                  <div className="text-sm">
                    {formData.ageFactor ? `${formData.ageFactorCompany}%` : ""}
                  </div>
                </div>
              </div>
              <div>
                <label className="block mb-2 font-semibold text-lg text-themeBlue">
                  <p className="text-themeBlue">Age To</p>
                </label>
                <input
                  type="date"
                  className="w-full border px-4 py-2 rounded"
                  value={formData.ageToCompany || ""}
                  onChange={e =>
                    handleChange(
                      "ageToCompany",
                      moment(e.target.value).format("YYYY-MM-DD")
                    )
                  }
                />
              </div>
            </div>
          </div>

          <div className="w-full mt-10">
            <h3 className="text-lg font-semibold text-center mb-4 text-themeBlue">
              Aging Factor - Company Data
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <label className="block mb-2 font-semibold text-lg text-themeBlue">
                  <p className="text-themeBlue">Aging Factor</p>
                </label>
                <div className="flex items-center gap-x-2 mt-5">
                  <div className="text-sm">0%</div>
                  <input
                    type="range"
                    className="w-full"
                    min={0}
                    max={100}
                    step={1}
                    value={formData.ageFactor || 0}
                    onChange={e =>
                      handleChange("ageFactor", e.target.value)
                    }
                  />
                  <div className="text-sm">
                    {formData.ageFactor
                      ? `${formData.ageFactor}%`
                      : ""}
                  </div>
                </div>
              </div>
              <div>
                <label className="block mb-2 font-semibold text-lg text-themeBlue">
                  <p className="text-themeBlue">Age To</p>
                </label>
                <input
                  type="date"
                  className="w-full border px-4 py-2 rounded"
                  value={formData.ageTo || ""}
                  onChange={e =>
                    handleChange(
                      "ageTo",
                      moment(e.target.value).format("YYYY-MM-DD")
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (stepIndex === 2) {
      return (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <CustomDropdown
            name="rewardElement"
            label="Reward Element"
            placeholder="Select Reward..."
            isMulti
            // allowCustomInput // ✅ Enables the custom number entry
            options={hookDataMap.rewardElement}
            value={formData.rewardElement || []}
            onChange={val => handleChange("rewardElement", val)}
          />
        </div>
      );
    }
    if (stepIndex === 3) {
      return (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <CustomDropdown
            name="showDataOn"
            label="Show Data On"
            placeholder="Select or enter percentile..."
            isMulti
            allowCustomInput // ✅ Enables the custom number entry
            options={hookDataMap.showDataOn}
            value={formData.showDataOn || []}
            customInputLimit={2}
            // canDeleteCustomValues={true}
            onChange={val => handleChange("showDataOn", val)}
          />
        </div>
      );
    }

    // Default dropdown rendering
    const dropdowns = dropdownConfig[stepIndex] || [];
    let isPreviousFilled = true;

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-4 items-center">
        {dropdowns.map((drop, idx) => {
          const value = formData[drop.name];
          let options = hookDataMap[drop.name];

          if (drop.name === "country" && selectedRegion) {
            const regionKey = livePayRegions?.data
              ?.find(region => region.id === selectedRegion)?.name;
            options = hookDataMap.country[regionKey] || [];
            // const regionKey = businessUnits?.data
            //   ?.find(bu =>
            //     bu.regions.some(region => region.id === selectedRegion)
            //   )
            //   ?.regions.find(region => region.id === selectedRegion)?.name;
            // options = hookDataMap.country[regionKey] || [];
          }

          if (!Array.isArray(options)) options = [];
          {
            /* 
          const isDisabled =
            createOwnPeerBasket && stepIndex === 1
              ? true
              : !isPreviousFilled; */
          }

          let isDisabled =
            createOwnPeerBasket && stepIndex === 1 ? true : !isPreviousFilled;

          if (drop.name === "grade" && formData.reportType === "title") {
            isDisabled = true;
          }
          if (
            (drop.name === "jobFunction" || drop.name === "subJobFunction") &&
            formData.reportType === "grade"
          ) {
            isDisabled = true;
          }

          {
            /* isPreviousFilled =
            isPreviousFilled && value !== undefined && value !== ""; */
          }

          const isReportTypeGrade = formData.reportType === "grade";
          const isReportTypeTitle = formData.reportType === "title";
          const isDisabledField =
            (drop.name === "grade" && isReportTypeTitle) ||
            ((drop.name === "jobFunction" || drop.name === "subJobFunction") &&
              isReportTypeGrade);

          if (!isDisabledField) {
            isPreviousFilled =
              isPreviousFilled && value !== undefined && value !== "";
          }

          if (drop.type === "text") {
            return (
              <div key={drop.name}>
                <label className="block mb-2 font-semibold text-lg text-themeBlue">
                  <p className="text-themeBlue">{drop.label}</p>
                </label>
                <input
                  type="text"
                  className="w-full border px-4 py-2 rounded"
                  disabled={isDisabled}
                  value={value || ""}
                  onChange={e => handleChange(drop.name, e.target.value)}
                />
              </div>
            );
          }

          if (drop.type === "date") {
            return (
              <div key={drop.name}>
                <label className="block mb-2 font-semibold text-lg">
                  <p className="text-themeBlue">{drop.label}</p>
                </label>
                <input
                  type="date"
                  className={`w-full border px-4 py-2 rounded ${isDisabled && "text-gray-300"
                    }`}
                  disabled={isDisabled}
                  value={value || ""}
                  onChange={e =>
                    handleChange(
                      drop.name,
                      moment(e.target.value).format("YYYY-MM-DD")
                    )
                  }
                />
              </div>
            );
          }

          return (
            <CustomDropdown
              key={drop.name}
              {...drop}
              options={
                ["subJobFunction", "grade"].includes(drop.name)
                  ? [{ label: "All", value: "all" }, ...options]
                  : options
              }
              isMulti={["subJobFunction", "grade"].includes(drop.name)} // <-- Make it multi-select
              disabled={
                isDisabled ||
                (drop.name === "subJobFunction" && subJobFunctionLoading)
              }
              isLoading={
                drop.name === "subJobFunction" && subJobFunctionLoading
              }
              value={value}
              onChange={val =>
                drop.name === "region"
                  ? handleRegionChange(val)
                  : handleChange(drop.name, val)
              }
            />
          );
        })}

        {stepIndex === 1 && (
          <>
            <div className="col-span-2 mt-4 flex items-center gap-3">
              <input
                id="peerBasket"
                type="checkbox"
                className="h-4 w-4"
                checked={createOwnPeerBasket}
                onChange={e => handlePeerBasketToggle(e.target.checked)}
              />
              <label htmlFor="peerBasket" className="text-md font-semibold">
                Create my own peer basket
              </label>
            </div>
            {createOwnPeerBasket && (
              <div className="col-span-2 mt-4">
                <label className="block mb-2 font-semibold text-lg">
                  <p className="text-themeBlue">Select Companies</p>
                </label>
                <CustomDropdown
                  name="custom_companies"
                  placeholder="Select companies..."
                  isMulti
                  value={formData.custom_companies || []}
                  options={hookDataMap.peerCompanies}
                  onChange={val => handleChange("custom_companies", val)}
                />
                {Array.isArray(formData.custom_companies) &&
                  formData.custom_companies.length < 10 && (
                    <p className="text-red-500 text-sm mt-2">
                      Please select at least 10 companies.
                    </p>
                  )}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <div className="overflow-hidden bg-themeCore fixed inset-0 z-50 px-10 transition-all delay-75">
      <div className="relative mx-6 py-5 mt-10 w-full">
        <div className="Stepper max-w-5xl mx-auto mb-5 relative">
          <div
            className="protector absolute top-0 left-0 bg-transparent w-full h-full"
            style={{ zIndex: "1000" }}
          ></div>
          <StepperComponent
            steps={steps}
            currentStep={currentStep}
            onStepClick={toggleStep}
          />
        </div>
        <div className="rounded-lg bg-white flex flex-col max-w-7xl mx-auto">
          <div className="py-6 px-5">
            <div className="content mt-6 p-5 px-20 bg-white max-w-7xl h-96 overflow-y-auto custom-scrollbar">
              <h1 className="text-center font-bold text-3xl mb-14 mt-10">
                Dynamic Report
              </h1>
              {steps.map((step, index) =>
                openSteps.includes(index) ? (
                  <div
                    key={index}
                    ref={el => (stepRefs.current[index] = el)}
                    className="mb-10 px-32"
                  >
                    <p className="font-bold text-center text-xl text-themeBlue mt-5">
                      {step.title}
                    </p>
                    {renderDropdowns(index)}
                  </div>
                ) : null
              )}
            </div>
          </div>
        </div>

        <div className="text-center gap-6 flex justify-center mt-5">
          {currentStep === steps.length - 1 && (
            <button
              onClick={handleSubmit}
              disabled={!isFormComplete()}
              className={`px-10 py-3 font-semibold rounded transition ${isFormComplete()
                ? "bg-themeBlue text-white"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
                }`}
            >
              Confirm
            </button>
          )}
          {currentStep > 0 && (
            <button
              onClick={handleBack}
              className="px-10 py-3 bg-themeBlue text-white font-semibold rounded transition"
            >
              Back
            </button>
          )}
          {currentStep < steps.length - 1 && (
            <button
              onClick={handleNext}
              disabled={!isStepValid()}
              className={`px-10 py-3 font-semibold rounded transition ${isStepValid()
                ? "bg-themeBlue text-white"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
                }`}
            >
              Continue
            </button>
          )}
          <button
            onClick={handleClose}
            className="px-10 py-3 font-semibold rounded transition bg-themeBlue text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepperForm;
